import ListItem from "./components/listItem";
import * as Styled from "./styled";
import { functionService } from "../../../../../lib/functions";
import { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";

const Requests = ({ setActiveTab }) => {
  const navigate = useNavigate();
  const { recruiter_id, search_id } = useParams();
  const [shortlistedCandidateList, setShortlistedCandidateList] = useState([]);
  const getShortlistedCandiate = async () => {
    const { status, response } = await functionService.get(
      `recruiter/shortlisted-candidates/${recruiter_id}/${search_id}`,
      {}
    );
    if (status) {
      if(response.data.data.length!==0){

        setShortlistedCandidateList(response.data.data);
      }


    }
  };

  useEffect(() => {
    getShortlistedCandiate();
  }, []);

  const [selectedListCandidate, setSelectedListCandidate] = useState([]);

  const approveCandidate = async () => {
    let res = await functionService.post(
      `recruiter/approved-candidates/${recruiter_id}/${search_id}`,
      {
        candidates: [...selectedListCandidate],
      }
    );
    if (res.status === true) {
      setShortlistedCandidateList((dataToShow) => {
        return dataToShow.filter((currentStudent) => {
          if (selectedListCandidate.find((id) => id == currentStudent.id)) {
            return false;
          } else {
            return true;
          }
        });
      });
    }
  };

  const confirmRequest = async () => {
    await functionService.post("recruiter/change-status", {
      search_id: search_id,
      status: "CONFIRMED",
    });
  };

  const rejectCandidate = async () => {
    let res = await functionService.post(
      `recruiter/rejected-candidates/${recruiter_id}/${search_id}`,
      {
        candidates: [...selectedListCandidate],
      }
    );
    if (res.status === true) {
      setShortlistedCandidateList((dataToShow) => {
        return dataToShow.map((currentStudent) => {
          if (selectedListCandidate.find((id) => id === currentStudent.id)) {
            return {...currentStudent,status:'REJECTED'}
          } else {
            return currentStudent;
          }
        });
      });
    }
  };
  const sendWhatsappRequest = async () => {
    let res = await functionService.post(
      `recruiter/whatsapp-message/${recruiter_id}/${search_id}`,
      {
        candidates: [...selectedListCandidate],
      }
    );
    if (res.status === true) {
      setShortlistedCandidateList((dataToShow) => {
        return dataToShow?.map((currentStudent) => {
          if (
            selectedListCandidate.find(({ id }) => id === currentStudent.id)
          ) {
            return { ...currentStudent, whatsapp_status: true };
          } else {
            return currentStudent;
          }
        });
      });
      getShortlistedCandiate()
    }
  };
  return (
    <Styled.ContainerDiv>
      <div>
        <div
          style={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <div
            style={{
              display: "flex",
              justifyContent: "flex-start",
              alignItems: "center",
            }}
          >
            <input
              onChange={(e) => {
                if (e.target.checked) {
let list = [];

                    shortlistedCandidateList?.filter(({ id,consent,status }) =>{return consent===null&&status!=='REJECTED' && list.push(id)})
                  setSelectedListCandidate(list)
                } else {
                  setSelectedListCandidate([]);
                }
              }}
              type="checkbox"
            />
            <Styled.Button
              onClick={() => {
                approveCandidate();
                confirmRequest();
              }}
            >
              Approve
            </Styled.Button>

            <Styled.Button
              onClick={() => {
                rejectCandidate();
              }}
            >
              Reject
            </Styled.Button>

            <Styled.Button
              onClick={() => {
                sendWhatsappRequest();
              }}
              disabled={selectedListCandidate?.length==0}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}

              >
                ̀
                <img
                  style={{ marginRight: "10px", height: "16px" }}
                  src="/whatsapp1.svg"
                />
                Send Whatsapp Request and Email
              </div>
            </Styled.Button>
          </div>
          <div>
            <Styled.Button 
              onClick={() => navigate("/candidateRequest/upload-shortlist", { replace: true })}
            >
              Upload Shortlist
            </Styled.Button>
            <Styled.SecondaryButton
              onClick={() => {
                setActiveTab(1);
              }}
            >
              <div
                style={{
                  display: "flex",
                  justifyContent: "center",
                  alignItems: "center",
                }}
              >
                ̀
                <img
                  style={{ marginRight: "10px", height: "16px" }}
                  src="/edit.svg"
                />
                Modify
              </div>
            </Styled.SecondaryButton>
          </div>
        </div>
      </div>
      {shortlistedCandidateList.length > 0 && shortlistedCandidateList?.map((currentCandidateDetails,index) => {
        return (
          <ListItem
            profile_image={currentCandidateDetails.profile_image}
            selectedListCandidate={selectedListCandidate}
            setSelectedListCandidate={setSelectedListCandidate}
            location={currentCandidateDetails.location}
            whatsapp_status={currentCandidateDetails.whatsapp_status}
            experience_month={currentCandidateDetails.experience_month % 12}
            experience_year={Math.floor(
              currentCandidateDetails.experience_month / 12
            )}
            userImage={currentCandidateDetails.experience_year}
            skills={currentCandidateDetails.skillsdata.filter(
              ({ top_percentile }) => top_percentile
            )}
            studentId={currentCandidateDetails.id}
            candidateID={currentCandidateDetails.id}
            resume={currentCandidateDetails.resume}
            profileName={currentCandidateDetails.name}
            emailId={currentCandidateDetails.email}
            phone={currentCandidateDetails.phone}
            setShortlistedCandidateList={setShortlistedCandidateList}
            whatsappConsent={currentCandidateDetails.consent}
            getShortlistedCandiate={getShortlistedCandiate}
            status={currentCandidateDetails?.status}
            designation={currentCandidateDetails?.designation}
            feedback={currentCandidateDetails?.rejection_feedback}
          />
        );
      })}
    </Styled.ContainerDiv>
  );
};
export default Requests;
